const MARKET_DATA_ROUTE = '/market-data';
const BLUE_SKY_ROUTE = '/blue-sky';

export const ROUTES = {
    blueSkyMonitor: `${MARKET_DATA_ROUTE}${BLUE_SKY_ROUTE}/stock/:symbol`,
    blueSkyMonitorPath: `${MARKET_DATA_ROUTE}${BLUE_SKY_ROUTE}/stock`,
    blueSkyRules: `${MARKET_DATA_ROUTE}${BLUE_SKY_ROUTE}/rules/:jurisdiction`,
    blueSkyRulesPath: `${MARKET_DATA_ROUTE}${BLUE_SKY_ROUTE}/rules`,
    stateSecuritiesCommissionsUrl: 'https://www.nasaa.org/contact-your-regulator/'
};
